<template>
  <div class="address-info">
    <div class="title">{{ $t('PCUserInfo.index.647kboa07d00') }}</div>
    <div class="item">
      <div class="item-left">{{ $t('PCUserInfo.index.647kboa07jk0') }}</div>
      <!-- <div class="item-right" @click="showCountryPicker = true">
        <input v-model="form.country" type="text"  placeholder="Seleccionar" />
      </div> -->

      <div class="item-right" @click="showCountryPicker = true">
        <input
          v-model="form.countryName"
          type="text"
          readonly
          :placeholder="$t('PCUserInfo.index.647kboa07p80')"
        />
        <img src="../../../assets/image/settleAccount/arrow.png" alt="" />
      </div>
    </div>
    <div class="item">
      <div class="item-left">{{ $t('PCUserInfo.index.647kboa08b40') }}</div>
      <div class="item-right">
        <input
          v-model="form.pinCode"
          type="text"
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
          @input="inputChange"
          @blur="blur"
          @focus="inputChange"
        />
        <!-- 邮编模糊搜索列表 -->
        <div class="van-list-wrapper pxstrict" v-show="isShowSearch">
          <van-list
            v-model="searchLoading"
            :finished="searchFinished"
            finished-text=""
            @load="onLoadSearch"
          >
            <div
              class="search-item"
              v-for="(item, index) in searchList"
              :key="`search-item-${index}`"
              @click="chooseCode(item.postCode)"
            >
              <span v-html="item._name" class="name"></span>
            </div>
          </van-list>
        </div>
      </div>
    </div>

    <div class="item">
      <div :class="['item-left', !form.pinCode ? 'gray-title' : '']">
        {{ $t('PCUserInfo.index.647kboa08h00') }}
      </div>
      <div class="item-right" @click="select">
        <input
          v-model="form.city"
          type="text"
          readonly
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
        />
        <img src="../../../assets/image/settleAccount/arrow.png" alt="" />
      </div>
    </div>

    <div class="item">
      <div :class="['item-left']">
        {{ $t('PCUserInfo.index.647kboa0idc0') }}
        <el-tooltip effect="dark" placement="top">
          <div slot="content" style="white-space: pre-line">
            {{ $t('PCUserInfo.index.647kboa0idc2') }}
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <div class="item-right">
        <input
          v-model="form.idCard"
          type="text"
          @input="formatIdCard"
          @blur="validateIdCard"
          maxlength="30"
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
        />
        <div v-if="idCardError" class="error-tip">{{ idCardError }}</div>
        <!-- <img src="../../../assets/image/settleAccount/arrow.png" alt="" /> -->
      </div>
    </div>

    <div class="item">
      <div class="item-left">{{ $t('PCUserInfo.index.647kboa08zc0') }}</div>
      <div class="item-right">
        <!-- <textarea
          v-model="form.address"
          class="textarea"
          maxlength="255"
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
        ></textarea> -->
        <van-field
          v-model="form.address"
          rows="2"
          autosize
          type="textarea"
          maxlength="105"
          :placeholder="$t('PCUserInfo.index.addreddPlaceholder')"
          show-word-limit
        />
      </div>
    </div>
    <!-- 国家/城市选择 -->
    <van-popup v-model="showCountryPicker" round position="bottom" class="popup">
      <div class="title">
        <div class="name">{{ $t('PCUserInfo.index.647kboa07jk0') }}</div>
        <img
          @click="showCountryPicker = false"
          src="../../../assets/image/settleAccount/close.png"
          alt=""
        />
      </div>
      <div class="list">
        <div
          v-for="(item, index) in countryList"
          :key="index"
          class="select-item"
          @click.stop="chooseCountry(item)"
        >
          <span>{{ item.country }}</span>
          <img
            v-if="form.countryCode === item.countryCode"
            src="../../../assets/image/settleAccount/choose.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>

    <!-- 国家/城市选择 -->
    <van-popup v-model="showPicker" round position="bottom" class="popup">
      <div class="title">
        <div class="name">{{ $t('PCUserInfo.index.647kboa08h00') }}</div>
        <img
          @click="showPicker = false"
          src="../../../assets/image/settleAccount/close.png"
          alt=""
        />
      </div>
      <div class="list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="select-item"
          @click="chooseCity(item.placeName)"
        >
          <span>{{ item.placeName }}</span>
          <img
            v-if="form.city === item.placeName"
            src="../../../assets/image/settleAccount/choose.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getPostCode, getCities, getCountries } from '../../../services/api/settleAccount';
export default {
  name: 'addressInfo',
  props: {
    info: Object
  },
  data() {
    return {
      form: {
        countryName: '',
        countryCode: '',
        pinCode: '',
        city: '',
        idCard: '',
        address: '',
        pageSize: 30,
        currentPage: 1
      },
      list: [],
      showCountryPicker: false,
      showPicker: false,
      searchList: [],
      timer: null,
      searchLoading: false,
      searchFinished: false,
      loading: true,
      isShowSearch: false,
      countryList: [{ country: 'España', countryCode: 'ES', placeName: '', postCode: '' }],

      idCardError: ''
    };
  },
  watch: {
    /**
     * 监听搜索数据变动并且更改
     */
    searchList() {
      this.searchList.forEach(it => {
        //高亮关键字
        it._name = it.postCode.replace(
          this.form.pinCode.trim(),
          `<span style="color:#405FFF;">${this.form.pinCode.trim()}</span>`
        );
      });
    },
    /**
     * 监听表单数据填写
     */
    form: {
      deep: true,
      immediate: true,
      handler: function (val) {
        let flag = Boolean(
          val && val.countryCode && val.pinCode && val.city && val.address && val.idCard && !this.idCardError
        );
        let data = {
          flag,
          form: val
        };
        this.$emit('completeAddress', data);
      }
    }
  },
  mounted() {
    let textarea = document.querySelector('textarea');
    textarea.addEventListener('input', e => {
      textarea.style.height = '20px';
      textarea.style.height = e.target.scrollHeight + 'px';
    });

    const { countryCode, pinCode, city, address, idCard } = this.info;
    this.form = {
      countryName: countryCode ? 'España' : '',
      countryCode,
      pinCode,
      city,
      address,
      pageSize: 30,
      currentPage: 1,
      idCard
    };

    // this.getCountries();
  },
  methods: {
    // handleInput(event) {
    //   console.log(event.target.value);
    //   const filteredValue = event.target.value.replace(/[^a-zA-Z0-9\+\-\/]/g, '').toUpperCase();

    //   // 更新 form.idCard
    //   this.form.idCard = filteredValue;
    // },

    formatIdCard(event) {
      // 1. 过滤非法字符并转大写
      const value = event.target.value
        .replace(/[^a-zA-Z0-9\-/]/g, '')
        .toUpperCase();
      
      // 2. 更新模型
      this.form.idCard = value.substring(0, 30);
      
      // 3. 实时验证
      this.validateIdCard();
    },

    validateIdCard() {
      if (!this.form.idCard) {
        this.idCardError = this.$t('PCUserInfo.index.647kboa09u40');
      } else if (this.form.idCard.length < 6) {
        this.idCardError = this.$t('PCUserInfo.index.idError');
      } else if (!/^[A-Z0-9\-/]{6,30}$/.test(this.form.idCard)) {
        this.idCardError = this.$t('PCUserInfo.index.idError');
      } else {
        this.idCardError = '';
      }
    },

    // 获取国家
    // getCountries() {
    //   getCountries()
    //     .then(res => {
    //       let { code, data } = res;
    //       if (code === '0000') {
    //         this.countryList = data;
    //         this.postCodeList = [];
    //       }
    //     })
    //     .catch(err => {});
    // },
    /**
     * 邮编输入内容修改
     */
    inputChange(data) {
      let value = data.target.value;
      console.log('value', value);
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.searchList = [];
      this.searchFinished = false;
      this.searchLoading = false;
      this.loading = true;
      this.form.currentPage = 1;
      this.timer = setTimeout(() => {
        this.search();
      }, 500);
    },
    /**
     * 模糊搜索邮编
     */
    search() {
      let data = {
        countryCode: this.form.countryCode,
        postCode: this.form.pinCode,
        pageIndex: 1,
        pageSize: 30
      };
      getPostCode(data)
        .then(res => {
          let { code, data } = res;
          if (code === '0000') {
            this.loading = false;
            this.searchList = this.searchList.concat(data.list);
            this.isShowSearch = this.searchList.length > 0;
            this.searchLoading = false;
            if (data.nextPage === 0) {
              this.searchFinished = true;
            }
          }
        })
        .catch(err => {});
    },
    /**
     * 搜索列表上拉加载
     */
    onLoadSearch() {
      if (!this.searchFinished) {
        this.searchLoading = true;
        this.form.currentPage++;
        this.search();
      }
    },
    /**
     * 选择邮编
     */
    chooseCode(data) {
      this.form.pinCode = data;
      this.form.city = '';
      this.isShowSearch = false;
      this.getCities();
    },
    /**
     * 邮编输入框失焦
     */
    blur() {
      // if (this.searchList.length === 0) {
      //   this.form.pinCode = '';
      // } else {
      //   setTimeout(() => {
      //     this.isShowSearch = false;
      //     this.getCities();
      //   }, 500);
      // }
    },
    /**
     * 获取城市数据
     */
    getCities() {
      let data = {
        countryCode: this.form.countryCode,
        postCode: this.form.pinCode
      };
      getCities(data)
        .then(res => {
          let { code, data } = res;
          if (code === '0000') {
            this.list = data;
          }
        })
        .catch(err => {});
    },
    chooseCountry(data) {
      this.form.countryCode = data.countryCode;
      this.form.countryName = data.country;
      this.form.pinCode = '';
      this.form.city = '';
      this.showCountryPicker = false;
      // this.search();
    },
    /**
     * 选择城市
     */
    chooseCity(data) {
      this.form.city = data;
      this.showPicker = false;
    },
    /**
     * 打开城市弹框城市
     */
    select() {
      if (!this.form.pinCode) return;
      this.showPicker = true;
    },
    /**
     * 关闭城市弹框
     */
    closeModal() {
      this.showPicker = false;
    }
  }
};
</script>

<style scoped lang="less">
.address-info {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px;
  .title {
    height: 84px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
    line-height: 84px;
  }
  .item {
    padding: 30px 0px 29px 0px;
    display: flex;
    // align-items: center;
    border-bottom: 1px solid #f4f5f7;
    position: relative;
    .item-left {
      width: 170px;
      font-size: 28px;
      color: #5d5f65;
      margin-right: 32px;
    }
    .gray-title {
      color: #999;
    }
    /deep/.item-right {
      flex: 1;
      color: #333;
      display: flex;
      align-items: center;
      position: relative;

      .van-cell{
        padding: 0;
      }

      input {
        flex: 1;
        border: none;
        padding: 0;
        font-size: 28px;
        color: #333;
      }
      input::placeholder {
        color: #999;
        font-size: 28px;
      }
      .input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          padding: 12px;
          color: #fff;
          background: #405fff;
          font-size: 24px;
          border-radius: 10px;
        }
      }
      img {
        width: 10px;
        height: 20px;
        margin-left: 20px;
      }
      .van-list-wrapper {
        //width: 239px;
        width: 100%;
        max-height: 160px;
        background: #fff;
        position: absolute;
        top: 44px;
        left: 0px;
        z-index: 99;
        overflow: auto;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);
        border-radius: 16px;
        padding: 16px;
        box-sizing: border-box;
        .search-item {
          font-size: 14px;
          margin-bottom: 16px;
          display: flex;
          justify-content: space-between;
          color: #333;
        }
      }
      .search-item:last-child {
        margin-bottom: 0;
      }
      .textarea {
        flex: 1;
        height: 120px;
        border: none;
        padding: 0;
        font-size: 28px;
        color: #333;
      }
      .textarea::placeholder {
        color: #999;
        font-size: 28px;
      }




      
      .error-tip{
        color: #F00;
        font-size: 24px;
        position: absolute;
        bottom: -30px;
      }
    }
  }
  .item:last-child {
    border-bottom: none;
  }
  .popup {
    .title {
      height: 96px;
      padding: 32px 40px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        color: #333;
        font-size: 32px;
        font-weight: 500;
      }
      img {
        width: 42px;
        height: 42px;
      }
    }
    .list {
      height: 796px;
      overflow: scroll;
      .select-item {
        height: 80px;
        padding: 20px 32px;
        box-sizing: border-box;
        position: relative;
        z-index: 1;
        span {
          font-size: 28px;
          color: #252629;
          font-weight: 600;
        }
        img {
          width: 84px;
          height: 10px;
          position: absolute;
          top: 46px;
          left: 32px;
          z-index: -1;
        }
      }
    }
  }
}
</style>
